import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { useModalTitle } from '../hooks';
import { closeAllModals, openModal } from '../store/modal.actions';
import { getModalParams } from '../store/modal.selector';
function withModal(Comp) {
    class WrappedComponent extends React.Component {
        render() {
            return React.createElement(Comp, { ...this.props });
        }
    }
    const mapStateToProps = (state) => ({
        modalParams: getModalParams(state),
    });
    const mapDispatchToProps = (dispatch) => bindActionCreators({
        closeModal: closeAllModals,
        openModal: openModal,
        useModalTitle: useModalTitle,
    }, dispatch);
    return compose(connect(mapStateToProps, mapDispatchToProps), withHandlers({
        openModalHandler: ({ openModal }) => (prop) => () => {
            openModal(prop);
        },
        closeModalHandler: ({ closeModal }) => () => {
            closeModal();
        },
    }))(WrappedComponent);
}
export default withModal;
//# sourceMappingURL=withModal.js.map